import _regeneratorRuntime from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import ChatManagerInstance from "./ChatManager";
import FirebaseBaseSessionAsync from "./FirebaseBaseSessionAsync";
import HttpStatus from "http-status-codes";
import axios from "axios";

var BaseSessionAsync = /*#__PURE__*/function () {
  function BaseSessionAsync(userName, accessToken) {
    _classCallCheck(this, BaseSessionAsync);

    this._id = "_" + Math.random().toString(36).substr(2, 9);
    this.userName = userName.toLowerCase();
    this.accessToken = accessToken;
  }

  _createClass(BaseSessionAsync, [{
    key: "buildHeaders",
    value: function buildHeaders() {
      return {
        "X-Partner-Name": ChatManagerInstance.partnerName,
        "Authorization": "Bearer " + this.accessToken,
        "Content-Type": "application/json"
      };
    }
  }, {
    key: "getAPIRequestFirebaseAccessURL",
    value: function getAPIRequestFirebaseAccessURL() {
      return "";
    }
  }, {
    key: "buildFirebaseSession",
    value: function buildFirebaseSession() {
      return new FirebaseBaseSessionAsync(this._id);
    }
  }, {
    key: "initializeFirebaseSession",
    value: function () {
      var _initializeFirebaseSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(accessJsonResponse) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.firebaseSession = this.buildFirebaseSession();
                _context.next = 3;
                return this.firebaseSession.connect(accessJsonResponse);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initializeFirebaseSession(_x) {
        return _initializeFirebaseSession.apply(this, arguments);
      }

      return initializeFirebaseSession;
    }()
  }, {
    key: "requestFirebaseAccess",
    value: function () {
      var _requestFirebaseAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.doGETRequest(this.getAPIRequestFirebaseAccessURL(), /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error, jsonResponse) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!error) {
                              _context2.next = 4;
                              break;
                            }

                            throw error;

                          case 4:
                            _context2.next = 6;
                            return _this.initializeFirebaseSession(jsonResponse);

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2, _x3) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function requestFirebaseAccess() {
        return _requestFirebaseAccess.apply(this, arguments);
      }

      return requestFirebaseAccess;
    }()
  }, {
    key: "doGETRequest",
    value: function () {
      var _doGETRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, doGETRequestHandler, abortSignal) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.doAPIRequest(url, "GET", void 0, doGETRequestHandler, abortSignal);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function doGETRequest(_x4, _x5, _x6) {
        return _doGETRequest.apply(this, arguments);
      }

      return doGETRequest;
    }()
  }, {
    key: "doAPIRequest",
    value: function () {
      var _doAPIRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, method, dataBody, apiRequestHandler, signal) {
        var response, responseJson;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetch(url, {
                  method: method,
                  headers: this.buildHeaders(),
                  body: JSON.stringify(dataBody),
                  signal: signal
                });

              case 3:
                response = _context5.sent;
                responseJson = {};

                if (!response.ok) {
                  _context5.next = 16;
                  break;
                }

                if (!(response.status == HttpStatus.NO_CONTENT)) {
                  _context5.next = 10;
                  break;
                }

                responseJson = {};
                _context5.next = 13;
                break;

              case 10:
                _context5.next = 12;
                return response.json();

              case 12:
                responseJson = _context5.sent;

              case 13:
                if (!apiRequestHandler) {
                  _context5.next = 16;
                  break;
                }

                _context5.next = 16;
                return apiRequestHandler(void 0, responseJson);

              case 16:
                _context5.next = 23;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5["catch"](0);

                if (!apiRequestHandler) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 23;
                return apiRequestHandler(_context5.t0);

              case 23:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 18]]);
      }));

      function doAPIRequest(_x7, _x8, _x9, _x10, _x11) {
        return _doAPIRequest.apply(this, arguments);
      }

      return doAPIRequest;
    }()
  }, {
    key: "doAxiosRequest",
    value: function () {
      var _doAxiosRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, method, dataBody) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios({
                  method: method,
                  url: url,
                  data: dataBody,
                  headers: this.buildHeaders()
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function doAxiosRequest(_x12, _x13, _x14) {
        return _doAxiosRequest.apply(this, arguments);
      }

      return doAxiosRequest;
    }()
  }, {
    key: "uploadResourceRequest",
    value: function () {
      var _uploadResourceRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(url, method, dataBody) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios({
                  method: method,
                  url: url,
                  data: dataBody
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function uploadResourceRequest(_x15, _x16, _x17) {
        return _uploadResourceRequest.apply(this, arguments);
      }

      return uploadResourceRequest;
    }()
  }, {
    key: "handleErrorResponse",
    value: function handleErrorResponse(response) {
      if (response.status === HttpStatus.FORBIDDEN) {
        throw new Error("Not Authorized");
      }

      if (response.status === HttpStatus.BAD_REQUEST) {
        throw new Error("Bad Request");
      }

      if (response.status === HttpStatus.NOT_FOUND) {
        throw new Error("Resource not found");
      }

      if (response.status === HttpStatus.CONFLICT) {
        throw new Error("Conflict on writting resource");
      }

      throw new Error("Server error");
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }]);

  return BaseSessionAsync;
}();

export { BaseSessionAsync as default };